
export const sortUnits = [
  'minute',
  'hour',
  'day',
  'week',
  'month',
  'year',
];

const presets = {
  Today: {
    value: 0,
    unit: 'day',
    round: true,
  },
  'This week': {
    value: 0,
    unit: 'week',
    round: true,
  },
  'This month': {
    value: 0,
    unit: 'month',
    round: true,
  },
  'This year': {
    value: 0,
    unit: 'year',
    round: true,
  },
};

export default presets;